export default "__VITE_ASSET__425b765d__"